import { concatMap, tap, map } from 'rxjs/operators';
import { HttpServiceBase, RxUtils, TypeUtils } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { BulkUploadTask } from './bulk-upload-task.class';

export class BulkFleetVehicleUploadService extends HttpServiceBase {
	constructor() {
		super('bulk');
	}

	downloadBulkTemplateFile() {
		return httpService.get<BlobPart>(this.getUrl(), 'template', { responseType: 'blob' }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.downloadBulkTemplateFile.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty')))
		);
	}

	uploadFileByAdmin(organizationId: string, body: FormData) {
		return httpService
			.post<BulkUploadTask>(this.getUrl(), `admin-upload/${organizationId}`, {
				body,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			.pipe(
				tap((result) => logger.debug(`[${this.constructor.name}.${this.uploadFileByAdmin.name}]`, result)),
				map((entity) => TypeUtils.convert(BulkUploadTask, entity))
			);
	}

	uploadBulkTemplateFile(body: FormData) {
		return httpService.post<BulkUploadTask>(this.getUrl(), 'upload', { body, headers: { 'Content-Type': 'multipart/form-data' } }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.uploadBulkTemplateFile.name}]`, result)),
			map((entity) => TypeUtils.convert(BulkUploadTask, entity))
		);
	}

	preUploadBulkTemplateFile(body: FormData) {
		return httpService
			.post<string>(this.getUrl(), 'pre-upload', { body, headers: { 'Content-Type': 'multipart/form-data' } })
			.pipe(tap((result) => logger.debug(`[${this.constructor.name}.${this.preUploadBulkTemplateFile.name}]`, result)));
	}

	get(id: string) {
		return httpService.get<BulkUploadTask>(this.getUrl(), id).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.get.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((entity) => TypeUtils.convert(BulkUploadTask, entity))
		);
	}

	getLatest(disableLoader = false) {
		return httpService.get<BulkUploadTask[]>(this.getUrl(), 'latest/one', { disableLoader }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getLatest.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(BulkUploadTask, result)?.[0])
		);
	}

	getAll() {
		return httpService.get<BulkUploadTask[]>(this.getUrl()).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getAll.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((entities) => TypeUtils.convert(BulkUploadTask, entities))
		);
	}
}

export const bulkFleetVehicleUploadService = new BulkFleetVehicleUploadService();
